import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuccessfulEnrollmentsEmptyState = ({
  flowObjectTypeId,
  isFilterApplied,
  onClearFilters
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    padding: "1000",
    textAlign: "center",
    borderBlockStartWidth: "100",
    borderBlockStartColor: "border-core-default",
    borderBlockStartStyle: "solid",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "empty-state-charts",
      width: "40%",
      className: "m-y-6"
    }), isFilterApplied ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation.enrollmentHistory.panel.enrollment-list.noFilterResults_cob",
          objectTypeId: flowObjectTypeId
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClearFilters,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentHistory.panel.enrollment-list.filter.resetFilters"
        })
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-management.enrollmentHistoryPanel.emptyState_cob",
      objectTypeId: flowObjectTypeId
    })]
  });
};
export default SuccessfulEnrollmentsEmptyState;